import { render, staticRenderFns } from "./HWP_Modal_OneTime_Legacy.vue?vue&type=template&id=5089d539&"
import script from "./HWP_Modal_OneTime_Legacy.vue?vue&type=script&lang=js&"
export * from "./HWP_Modal_OneTime_Legacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports